import React from "react";

import { observer } from "mobx-react";

import { useStores } from "../../contexts/StoreContext";
import BarFooter from "./BarFooter/BarFooter";
import CenteredFooter from "./CenteredFooter";
import CustomFooter from "./CustomFooter";
import DefaultFooter from "./DefaultFooter";
import MultiColumnFooter from "./MultiColumnFooter/MultiColumnFooter";

function Footer(props) {
  const { footerStore } = useStores();
  const { footerType } = footerStore;

  switch (footerType) {
    case "custom":
      return <CustomFooter {...props} />;
    case "bar":
      return <BarFooter {...props} />;
    case "centered":
      return <CenteredFooter {...props} />;
    case "multiColumn":
      return <MultiColumnFooter {...props} />;
    default:
      return <DefaultFooter {...props} />;
  }
}

export default observer(Footer);
